function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InputFilterEvent {}
/** table object for a given panel has changed */
_defineProperty(InputFilterEvent, "TABLE_CHANGED", 'InputFilterEvent.TABLE_CHANGED');
/** columns list for a given panel has changed */
_defineProperty(InputFilterEvent, "COLUMNS_CHANGED", 'InputFilterEvent.COLUMNS_CHANGED');
/** The filter values from an filter panel have changed */
_defineProperty(InputFilterEvent, "FILTERS_CHANGED", 'InputFilterEvent.FILTERS_CHANGED');
/** Clear all the values in currently open filter panels */
_defineProperty(InputFilterEvent, "CLEAR_ALL_FILTERS", 'InputFilterEvent.CLEAR_ALL_FILTERS');
/** A column was selected from an input filter panel */
_defineProperty(InputFilterEvent, "COLUMN_SELECTED", 'InputFilterEvent.COLUMN_SELECTED');
/** Open a Dropdown filter panel */
_defineProperty(InputFilterEvent, "OPEN_DROPDOWN", 'InputFilterEvent.OPEN_DROPDOWN');
/** Open an input filter panel */
_defineProperty(InputFilterEvent, "OPEN_INPUT", 'InputFilterEvent.OPEN_INPUT');
/** Open a filter set manager panel */
_defineProperty(InputFilterEvent, "OPEN_FILTER_SET_MANAGER", 'InputFilterEvent.OPEN_FILTER_SET_MANAGER');
export default InputFilterEvent;
//# sourceMappingURL=InputFilterEvent.js.map